<ui-section>
  <ui-block width="4x">
    <ui-form
      [config]="modeFormConfig"
      [(formValues)]="modeFormValues"
      (formValuesChange)="onModeFormValuesChange($event)"
      (buttonClick)="onModeFormButtonClick($event)"
    ></ui-form>
  </ui-block>
  <ui-block>

  </ui-block>
</ui-section>
<!-- <pre><code>{{ modeCodeSample() }}</code></pre> -->

<markdown [data]="modeCodeMarkdown()" />

<p class="mode-note">
  {{ lastContextMenuEventText() }}
</p>

@if (showClientNonAutoLoadModeNote()) {
  <p class="mode-note">
    In Client | [rowData] mode, data renders as soon as <code>rowData</code> is assigned. Non-auto load modes only affect server-backed loads.
  </p>
}

@if (showGrid()) {
  @if (selectedScenario() === "client-rowData") {
    <ui-grid
      [rowData]="rowData()"
      [columnDefs]="colDefs"
      [showPanelHeader]="true"
      [panelHeaderConfig]="panelHeaderConfig"
      [showStandardFilterControls]="true"
      [filterInputConfigs]="filterInputConfigs"
      [contextMenuConfig]="contextMenuConfig"
      [loadMode]="selectedLoadMode()"
      [reloadOnChangeTrigger]="manualReloadTrigger()"
      [pageSizes]="[5, 10, 20]"
    ></ui-grid>
  } @else if (selectedScenario() === "server-endpoint") {
    <ui-grid
      [readEndpoint]="'mock/StarWarsActors'"
      [columnDefs]="colDefs"
      [showPanelHeader]="true"
      [panelHeaderConfig]="panelHeaderConfig"
      [showStandardFilterControls]="true"
      [filterInputConfigs]="filterInputConfigs"
      [contextMenuConfig]="contextMenuConfig"
      [loadMode]="selectedLoadMode()"
      [reloadOnChangeTrigger]="manualReloadTrigger()"
      [pageSizes]="[5, 10, 20]"
    ></ui-grid>
  } @else {
    <ui-grid
      [dsConfig]="serverDsConfig"
      [columnDefs]="colDefs"
      [showPanelHeader]="true"
      [panelHeaderConfig]="panelHeaderConfig"
      [showStandardFilterControls]="true"
      [filterInputConfigs]="filterInputConfigs"
      [contextMenuConfig]="contextMenuConfig"
      [loadMode]="selectedLoadMode()"
      [reloadOnChangeTrigger]="manualReloadTrigger()"
      [pageSizes]="[5, 10, 20]"
    ></ui-grid>
  }
}
